import { memo } from 'react';

type SvgProps = React.ComponentPropsWithoutRef<'svg'>;

export const AccordionIcon = memo(({ className, ...props }: SvgProps) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Top panel (collapsed) */}
      <rect x="3" y="3" width="18" height="5" rx="1" />
      <polyline points="15,5.5 16.5,5.5" />
      {/* Middle panel (expanded) */}
      <rect x="3" y="10" width="18" height="5" rx="1" />
      <polyline points="15,12.5 16.5,12.5" />
      {/* Bottom panel (collapsed) */}
      <rect x="3" y="17" width="18" height="5" rx="1" />
      <polyline points="15,19.5 16.5,19.5" />
    </svg>
  );
});

AccordionIcon.displayName = 'AccordionIcon';
